import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  class: "header"
}
const _hoisted_2 = { class: "container-fluid d-flex align-items-stretch justify-content-between" }
const _hoisted_3 = { class: "d-none d-md-block lh-1" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_6 = {
  id: "kt_aside_mobile_toggle",
  class: "btn btn-icon btn-active-light-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_8 = { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-flex align-items-stretch justify-content-between top-bar-nav-buttons" }
const _hoisted_11 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Topbar = _resolveComponent("Topbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/modules/forms" }, {
          default: _withCtx(() => [
            (_ctx.hasRole('ROLE_FORMS_MOBILE'))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  alt: "Logo",
                  class: "h-30px logo",
                  src: _ctx.formsMobileLogo,
                  style: {"margin-top":"-8px","margin-right":"30px"}
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          style: _normalizeStyle(_ctx.hasRole('ROLE_FORMS_MOBILE') ? 'color:#808080' : '')
        }, _toDisplayString(_ctx.pageName), 5)
      ]),
      (!_ctx.hasRole('ROLE_FORMS_MOBILE'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/img/navigation/menu.svg" })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          class: "d-lg-none",
          to: _ctx.hasRole('ROLE_FORMS_MOBILE') ? '/modules/forms' : '/'
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "Logo",
              class: "header__logo",
              src: _ctx.mobileLogo
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Topbar)
        ])
      ])
    ])
  ]))
}